export enum VantaFramework {
  CCPA = 'CCPA',
  GDPR = 'GDPR',
  HIPAA = 'HIPAA',
  ISO27001 = 'ISO27001',
  PCI = 'PCI',
  SOC2 = 'SOC2',
}

export type VantaFrameworkCourses = {
  [key in VantaFramework]: number[];
};

export enum VantaCampaignSyncType {
  ALL = 'ALL',
  ETHENA = 'ETHENA',
}
